module.exports = __webpack_public_path__ + "img/vo-860.815582ae.jpg";